import { render, staticRenderFns } from "./NbReceiverInformation.vue?vue&type=template&id=64ffb2b5&"
import script from "./NbReceiverInformation.vue?vue&type=script&lang=js&"
export * from "./NbReceiverInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports